// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

// Import your existing views/components
import FirebaseUserManager from "@/components/product-viewer/FirebaseUserManager.vue";
import LoginView from '@/views/product-viewer/LoginView.vue';
import CategoriesView from '@/views/product-viewer/CategoriesView.vue';
import CatalogView from '@/views/product-viewer/CatalogView.vue';
import ProductView from '@/views/product-viewer/ProductView.vue';

// 1) Import the new coverage component
import AttributeCoverage from '@/views/product-viewer/AttributeCoverage.vue'; // or wherever you placed it
import TaxonomyEditorApp from '@/components/taxonomy-editor/TaxonomyEditorApp.vue';

// Create a promise to track when auth is ready
const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    );
  });
};

// Simple route guard that requires auth
const requireAuth = async (to, from, next) => {
  const user = await getCurrentUser();
  if (!user) {
    next({ name: 'login' });
  } else {
    next();
  }
};

const requirePermissions = (rolesNeeded) => async (_, __, next) => {
  const { dataManager, taxonomyManager } = rolesNeeded;
  // We still need to do a basic login check
  const user = await getCurrentUser();
  if (!user) return next({ name: 'login' });

  const { claims } = await user.getIdTokenResult();
  const dataManagerRole = claims['data-manager-role'];
  const taxonomyManagerRole = claims['taxonomy-manager-role'];

  // Ensure user has needed roles
  if ((dataManager && dataManagerRole === 'none') || (taxonomyManager && taxonomyManagerRole === 'none')) {
    return next({ name: 'login' });
  }

  return next();
  
}

const routes = [
  {
    path: '/',
    redirect: { name: 'categories' }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/categories',
    name: 'categories',
    component: CategoriesView,
    beforeEnter: requirePermissions({ dataManager: true }),
  },
  {
    path: '/catalog',
    name: 'catalog',
    component: CatalogView,
    beforeEnter: requirePermissions({ dataManager: true })
  },
  {
    path: '/product/:id',
    name: 'product',
    component: ProductView,
    props: true,
    beforeEnter: requirePermissions({ dataManager: true })
  },
  {
    path: '/admin',
    component: FirebaseUserManager,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // 2) Add your new "attribute coverage" route
  {
    path: '/attribute-coverage',
    name: 'attributeCoverage',
    component: AttributeCoverage,
    beforeEnter: requirePermissions({ dataManager: true }), // or a special admin guard if you prefer
  },

  {
    path: '/taxonomy-editor',
    name: 'taxonomyEditor',
    component: TaxonomyEditorApp,
    beforeEnter: requirePermissions({ taxonomyManager: true }),
  }
];

const router = createRouter({
  history: createWebHistory(), // EMMATODO: Fix to use process.env
  routes
});

export default router;
